export const products = {
  title: 'Gestión de Productos',
  searchPlaceholder: 'Buscar productos...',
  columns: {
    barcode: 'Referencia',
    category: 'Categoría',
    name: 'Designación',
    description: 'Descripción',
    price: 'Precio en Dh',
    cost: 'Costo',
    stock: 'Stock',
    isService: 'Tipo',
    image: 'Imagen',
    isActive: 'Estado',
    tauxTva: 'IVA',
    unite: 'Unidad',
    createdAt: 'Fecha de creación',
    updatedAt: 'Última modificación',
    lastSync: 'Última sincronización',
    packItems: 'Artículos del pack',
    modeleVenteId: 'Modelo de venta',
    // Secciones para columnas colapsables
    basicInfo: 'Información básica',
    financialInfo: 'Detalles financieros',
    systemInfo: 'Información del sistema'
  },
  filters: {
    search: {
      label: 'Búsqueda',
      placeholder: 'Buscar por nombre, referencia...'
    },
    sort: {
      label: 'Ordenar por',
      placeholder: 'Seleccionar campo',
      directions: {
        asc: 'Ascendente',
        desc: 'Descendente'
      }
    },
    category: {
      label: 'Categoría',
      allCategories: 'Todas las categorías'
    },
    type: {
      label: 'Tipo',
      all: 'Todos los tipos',
      product: 'Producto',
      service: 'Servicio',
      pack: 'Pack',
      matiere_premiere: 'Materia prima',
      piece_detachee: 'Pieza de recambio'
    },
    priceRange: {
      label: 'Rango de precios',
      allPrices: 'Todos los precios',
      ranges: {
        '0-100': '0 - 100 Dh',
        '100-500': '100 - 500 Dh',
        '500+': '500+ Dh'
      }
    },
    stockStatus: {
      label: 'Estado del stock',
      all: 'Todos',
      inStock: 'En stock',
      lowStock: 'Stock bajo',
      outOfStock: 'Sin stock'
    },
    dateRange: {
      label: 'Período',
      startDate: 'Fecha de inicio',
      endDate: 'Fecha de fin'
    }
  },
  actions: {
    newProduct: 'Nuevo Producto',
    delete: 'Eliminar'
  },
  pagination: {
    totalItems: 'Total de elementos',
    previous: 'Anterior',
    next: 'Siguiente',
    page: 'Página'
  },
  form: {
    createTitle: 'Nuevo Producto',
    editTitle: 'Modificar Producto',
    tabs: {
      main: 'Información principal',
      secondary: 'Información secundaria'
    },
    imageHelp: 'Haga clic para agregar una imagen',
    fields: {
      barcode: 'Referencia',
      name: 'Designación',
      category: 'Categoría',
      price: 'Precio',
      cost: 'Costo',
      tauxTva: 'IVA',
      stock: 'Stock',
      isService: 'Tipo de producto',
      image: 'Imagen'
    },
    placeholders: {
      barcode: 'Ingrese la referencia',
      name: 'Ingrese la designación',
      category: 'Seleccione una categoría',
      price: 'Ingrese el precio',
      stock: 'Ingrese el stock',
      image: 'Seleccione una imagen'
    },
    buttons: {
      save: 'Guardar',
      cancel: 'Cancelar'
    },
    validations: {
      required: 'Este campo es requerido',
      number: 'Por favor ingrese un número válido',
      positive: 'El número debe ser positivo'
    },
    create: 'Crear',
    update: 'Actualizar',
    cancel: 'Cancelar',
    submitting: 'Guardando...'
  },
  confirmations: {
    delete: '¿Está seguro de que desea eliminar este producto?'
  },
  common: {
    notDefined: 'No definido'
  },
  units: {
    piece: 'Unidad',
    kg: 'Kilogramo',
    g: 'Gramo',
    l: 'Litro',
    ml: 'Mililitro',
    m: 'Metro',
    cm: 'Centímetro',
    m2: 'Metro cuadrado',
    m3: 'Metro cúbico',
    h: 'Hora',
    forfait: 'Forfait'
  }
}; 